class BundleOffer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const input = event.target.closest('input[name="id"]');
    if (!input) return;

    const priceElement = this.querySelector('[data-price]');
    const compareElement = this.querySelector('[data-compare-price]');
    const savingElement = this.querySelector('[data-saving]');
    const rowElement = this.querySelector('[data-price-row]');

    if (priceElement && input.dataset.price) {
      priceElement.textContent = input.dataset.price;
    }

    if (compareElement && input.dataset.comparePrice) {
      compareElement.textContent = input.dataset.comparePrice;
    }

    if (savingElement && input.dataset.saving) {
      savingElement.textContent = input.dataset.saving;
    }

    if (rowElement) {
      if (input.dataset.comparePrice) {
        rowElement.removeAttribute('hidden');
      } else {
        rowElement.setAttribute('hidden', '');
      }
    }
  }
}

customElements.define('bundle-offer', BundleOffer);
